module.exports = __webpack_public_path__ + "static/media/medicine.80228a19.svg";